// #region Imports
import { safeNumber } from '../../../shared/helpers';
// #endregion

// #region Builders
export function buildServico(partial = {}) {
	return {
		id: partial.id ?? null,
		nome: partial.nome ?? '',
		categoria: partial.categoria ?? '',
		descricao: partial.descricao ?? '',
		preco_padrao: safeNumber(partial.preco_padrao),
		perc_comissao_padrao: safeNumber(partial.perc_comissao_padrao),
	};
}
// #endregion

// #region Mapeadores
export function servicoFromBackend(dto = {}) {
	return buildServico({
		id: dto.id,
		nome: dto.nome,
		categoria: dto.categoria,
		descricao: dto.descricao,
		preco_padrao: dto.preco_padrao ?? dto.precoPadrao ?? 0,
		perc_comissao_padrao: dto.perc_comissao_padrao ?? dto.percComissaoPadrao ?? 0,
	});
}
// #endregion

// #region Serialização
export function servicoToJSON(s) { return { ...s }; }
// #endregion

